<div class="modal-confirm">
  <span class="modal-confirm__title">{{ title() | translate }}</span>

  <span class="modal-confirm__text" [innerHTML]="text() | translate"></span>

  <div class="modal-confirm__footer">
    <cx-button *ngIf="showCancelButton()" (click)="onClose()" class="btn-outline w-100">
      {{ cancelButtonText() | translate }}
    </cx-button>
    <cx-button *ngIf="showConfirmButton()" (click)="onConfirm()" class="w-100">
      {{ confirmButtonText() | translate }}
    </cx-button>
  </div>
</div>
